import {
  Component,
  inject,
  InputSignal,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import {JwtService} from '../../../services/infrastructure/auth/jwt/jwt.service';
import {UserAvatarSize} from '../../../common/enums/user-avatar-size.enum';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon],
})
export class UserAvatarComponent {

  private jwtService: JwtService = inject(JwtService);

  public size: InputSignal<UserAvatarSize> = input<UserAvatarSize>(UserAvatarSize.Medium);

  /**
   * Method: Get avatar current account
   */
  public getPicture(): string {
    return this.jwtService.getPicture();
  }

  /**
   * Method: Get name current account
   */
  public getFullName(): string {
    return this.jwtService.getFullName();
  }

}
